import React from "react";
import { IMAGES } from "../lib/site";
import { Reveal } from "../components/Reveal";
import { PageHero, SectionHeader, CTAButton, FinalCTA, useSeo, Eyebrow } from "../components/Shared";

const MODEL = ["Produce", "Store", "Manage", "Fulfill", "Deliver", "Support"];

export default function About() {
  useSeo(
    "About MJG Promotions | One Partner for Your Brand",
    "MJG Promotions is a full-service marketing and event solutions company providing apparel, promotional products, exhibits, fulfillment, and event logistics from Fairfield, NJ."
  );
  return (
    <>
      <PageHero
        eyebrow="About MJG Promotions"
        title="One Partner for the Work Behind Your Brand"
        intro="A full-service marketing and event solutions company helping organizations bring their brands to life."
        image={IMAGES.warehouseWalk}
      />

      <section className="bg-white py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5">
          <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
            <div className="lg:col-span-7">
              <SectionHeader eyebrow="Who We Are" title="An Extension of Your Team" />
              <div className="mt-6 space-y-5 text-base leading-relaxed text-brand-charcoal">
                <p>MJG Promotions is a full-service marketing and event solutions company helping organizations bring their brands to life. We provide in-house apparel, promotional products, custom and rental trade show exhibits, and event services.</p>
                <p>Our team manages everything from inventory storage and fulfillment to shipping, setup, and event logistics. With our cloud-based portal, clients can manage and access their branded assets from anywhere.</p>
                <p className="text-lg font-bold text-brand-black">One partner. One solution. Everything you need to make your brand stand out.</p>
              </div>
            </div>
            <div className="lg:col-span-5">
              <img src={IMAGES.kitting} alt="Assembling a branded welcome kit at an MJG packing station" className="aspect-[4/5] w-full rounded-sm object-cover" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      {/* Connected service model */}
      <section className="bg-brand-black py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5">
          <SectionHeader dark eyebrow="Our Model" title="A Connected Service Model" body="Each capability strengthens the next — so your brand stays organized, consistent, and event-ready." />
          <div className="mt-12 flex flex-wrap items-center gap-3">
            {MODEL.map((m, i) => (
              <Reveal key={m} delay={i * 0.06} className="flex items-center gap-3">
                <span className="border border-white/15 px-6 py-4 text-base font-bold text-white">{m}</span>
                {i < MODEL.length - 1 && <span className="text-brand-red">→</span>}
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Photo strip */}
      <section className="bg-brand-warm py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5">
          <Eyebrow>Inside MJG</Eyebrow>
          <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {[
              { src: IMAGES.warehouseAisle, alt: "Warehouse racking" },
              { src: IMAGES.apparelRack, alt: "Apparel production and racks" },
              { src: IMAGES.packing, alt: "Packing station" },
              { src: IMAGES.exhibitCrowd, alt: "Event and exhibit floor" },
            ].map((im, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <img src={im.src} alt={im.alt} className="aspect-[3/4] w-full rounded-sm object-cover" loading="lazy" />
              </Reveal>
            ))}
          </div>
          {/* CLIENT-TODO placeholder: company history, mission, and leadership can be added here once approved. */}
          <div className="mt-10">
            <CTAButton to="/contact" testId="about-cta" variant="dark">Talk to Our Team</CTAButton>
          </div>
        </div>
      </section>

      <FinalCTA />
    </>
  );
}
